// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| EzClocker Input UX CSS Classes
| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
:root {
  --ezInputFontFamily: "Font-Family-ezClocker", "Roboto", "Noto Sans", "Verdana", "Arial", sans-serif;
  --ezInputMonospaceFontFamily: monospace;
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Input Styles
| Tags: <input/>
|-------------------------------------------------------------------
| Available Styles:
|   input <default>
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
input {
  font-family: var(--ezInputFontFamily);
  font-size: 12pt;
  padding: 4px;
  box-sizing: border-box;
  /* Opera/IE 8+ */
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 0;
  border-radius: 3px;
}

input:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

input:invalid {
  background-color: #ffeeee;
  border-color: #FF0700;
  border-width: 1px;
  box-shadow: none;
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Select Input Styles
| Tags: <select/>
|-------------------------------------------------------------------
| Available Styles:
|   ezSelectMenu
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
select {
  margin: 4px 4px 4px 0;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

select:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

select.reportsOverride,
select.ez-reports-override {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

select.reportsOverride:focus,
select.ez-reports-override:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

select.ezSelect {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

select.ezSelect:enabled:hover {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
}

select.ezSelect:enabled:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

select.ezSelectHeader {
  font-size: 12pt;
  font-weight: bold;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

select.ezSelectHeader:hover {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
}

select.ezSelectHeader:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Select Option Styles
| Tags: <option/>
|-------------------------------------------------------------------
| Available Styles:
|   option <tag default>
|   ezOption
|   ezOptionHeader
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
option {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

option:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

option.ezOption {
  font-size: 12pt;
  padding: 4px;
}

option.ezOptionHeader {
  font-size: 14pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  margin: 4px 4px 4px 0;
}

option.ezOptionHeader:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| JQuery Select Input Styles
| Tags: <select/>
|-------------------------------------------------------------------
| Available Styles:
|   ezSelectMenu
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
/* for jQuery's SelectMenu component */
.ezSelectMenu {
  width: auto;
  padding: 4px;
  margin: 4px 4px 4px 0;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

.ezSelectMenu:hover {
  color: var(--ezClockerBlack);
  font-weight: bold;
  background-color: #ffdb64;
}

.ezSelectMenu:active {
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-color: #ffcc66;
}

.ezSelectMenu:disabled {
  font-weight: normal;
  background-color: #ffdb64;
  color: #c69800;
  border-color: #c69800;
}

.ezSelectMenu:focus {
  color: var(--ezClockerBlack);
  font-weight: bold;
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */
  box-shadow: 0 0 2px 1px rgb(255 153 0/30%);
}

input[type=date].ezDate {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=date].ezDate:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=datetime].ezDateTime {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=datetime].ezDateTime:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=datetime-local].ezDateTimeLocal {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=datetime-local].ezDateTimeLocal:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=email].ezEmail {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=email].ezEmail:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=file].ezFile {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
}

input[type=image].ezImage {
  border-style: solid;
  border-color: var(--ezClockerGray);
  border-width: 1px;
}

input[type=image].ezImage:hover {
  border-style: solid;
  border-color: var(--ezClockerBlack);
  border-width: 1px;
}

input[type=month].ezMonth {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=month].ezMonth:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=number].ezNumber {
  font-size: 12pt;
  font-family: var(--ezInputFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=number].ezNumber:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=number].ezNumber:disabled {
  color: #e0e0e0;
  border-color: #e0e0e0;
  outline-color: #e0e0e0;
  outline-style: solid;
  outline-width: 1px;
}

input[type=password].ezPassword {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=password].ezPassword:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=radio].ezRadio {
  background-color: transparent;
}

input[type=reset].ezResetMajor {
  display: inline-block;
  padding: 6px 24px;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezClockerBlack);
  cursor: pointer;
}

input[type=reset].ezResetMajor:hover {
  background-color: #ffcc66;
}

input[type=reset].ezResetMajor:active {
  background-color: #ff9933;
}

input[type=reset].ezResetActionButton {
  display: inline-block;
  padding: 6px 24px;
  background-color: #8df13c;
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezActionGreenBorderColor);
  cursor: pointer;
}

input[type=reset].ezResetActionButton:hover {
  background-color: var(--ezActionGreenHoverColor);
}

input[type=reset].ezResetActionButton:active {
  color: var(--ezActionGreenHoverColor);
  background-color: var(--ezActionGreenBorderColor);
}

input[type=reset].ezResetEdit {
  display: inline-block;
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: normal;
  border-radius: 3px;
  border: 1px solid var(--ezClockerBlack);
  text-decoration: none;
  cursor: pointer;
}

input[type=reset].ezResetEdit:hover {
  background-color: #edf6ff;
}

input[type=reset].ezResetEdit:active {
  background-color: var(--ezClockerGray);
}

input[type=search].ezSearch {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerBlack);
  border-style: solid;
  border-width: 1px;
}

input[type=submit].ezMajorSubmit {
  display: inline-block;
  padding: 6px 24px;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezClockerBlack);
  cursor: pointer;
}

input[type=submit].ezMajorSubmit:hover {
  background-color: #ffcc66;
}

input[type=submit].ezMajorSubmit:active {
  background-color: #ff9933;
}

input[type=submit].ezSubmitActionButton {
  display: inline-block;
  padding: 6px 24px;
  background-color: #8df13c;
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: bold;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezActionGreenBorderColor);
  cursor: pointer;
}

input[type=submit].ezSubmitActionButton:hover {
  background-color: var(--ezActionGreenHoverColor);
}

input[type=submit].ezSubmitActionButton:active {
  color: var(--ezActionGreenHoverColor);
  background-color: var(--ezActionGreenBorderColor);
}

input[type=submit].ezSubmitEdit {
  display: inline-block;
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezInputFontFamily);
  font-size: 12px;
  font-weight: normal;
  text-decoration: none;
  border-radius: 3px;
  border: 1px solid var(--ezClockerBlack);
  cursor: pointer;
}

input[type=submit].ezSubmitEdit:hover {
  background-color: #edf6ff;
}

input[type=submit].ezSubmitEdit:active {
  background-color: var(--ezClockerGray);
}

input[type=tel].ezTel {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=tel].ezTel:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=text].ezText {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=text].ezText:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=time].ezTime {
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=time].ezTime:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=url].ezUrl {
  font-size: 12pt;
  padding: 4px;
  background-color: var(--ezClockerWhite);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=url].ezUrl:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

input[type=week].ezWeek {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
}

input[type=week].ezWeek:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
}

textarea {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  font-size: 12pt;
  font-family: "Roboto", Verdana, sans-serif;
  /* font-family: var(--ezInputMonospaceFontFamily); */
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

textarea:focus {
  border-color: var(--ezClockerOrange);
  outline-color: var(--ezClockerOrange);
  outline-style: solid;
  outline-width: 1px;
  border-radius: 3px;
}

textarea.mono-spaced {
  padding: 4px;
  background-color: var(--ezClockerWhite);
  font-size: 12pt;
  font-family: var(--ezInputMonospaceFontFamily);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

textarea.ez-error-message-details {
  margin: 8px;
  width: 100%;
  font-family: var(--ezInputMonospaceFontFamily);
  color: var(--ezClockerGray);
  font-size: 6pt;
  border-radius: 3px;
}

textarea.ezTextArea-noresize-w100 {
  resize: none;
  width: 99%;
}

textarea.ezTextArea-medium-100 {
  width: 99%;
}

.ezInputs-large-fake-editor {
  margin: 0;
  min-height: 24px;
  padding: 4px;
  box-sizing: border-box;
  background-color: var(--ezClockerWhite);
  font-family: Roboto, Verdana, sans-serif;
  font-size: 18pt;
  border-color: var(--ezClockerSilver);
  border-style: solid;
  border-width: 1px;
}

.ezInputs-large-fake-editor-no-border {
  margin: 0;
  min-height: 24px;
  padding: 4px;
  box-sizing: border-box;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerNavy);
  font-family: var(--ezInputFontFamily);
  font-size: 14pt;
  border-style: none;
}

.ezMajorInputLabel {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezFontColor);
  font-weight: bold;
  font-size: 16pt;
}

.ezInput-label-white-12pt-bold {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezClockerWhite);
  font-size: 12pt;
  font-weight: bold;
}

.ezInput-label-black-12pt-bold {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
}

.ezInput-label-black-14pt,
.ezInputLabel,
.ezEditorLabel,
.editorLabel {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezFontColor);
  font-size: 14pt;
}

.ezInput-label-black-14pt-bold,
.ezBoldInputLabel {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezFontColor);
  font-size: 14pt;
}

.ezInputs-checkbox-radio-label {
  padding-top: 4px;
  padding-bottom: 2px;
  color: var(--ezFontColor);
  font-size: 14pt;
  line-height: 18px;
  cursor: pointer;
}

.ezTogglesLabel {
  color: var(--ezFontColor);
  font-size: 14pt;
  text-align: left;
  vertical-align: middle;
}

.ezInputFormatLabel {
  color: var(--ezClockerGray);
  font-size: 10pt;
}

.ezLargeInputEditor {
  font-size: 18pt;
}

.ezInputs-authentication-full-width {
  box-sizing: border-box;
  width: 100%;
  font-size: 18pt;
}

.ezInputs-large-full-width {
  box-sizing: border-box;
  width: 100%;
  font-size: 12pt;
}

.ezOversizedEditor,
.oversizedEditor {
  font-size: 16pt;
  font-style: bold;
}

.ezDialogEditor {
  font-size: 12pt;
  box-sizing: border-box;
  width: 100%;
}

.ezFullWidthEditor,
.fullWidthEditor {
  width: 100%;
  box-sizing: border-box;
}

.ezInputLabelGroupContainer {
  padding: 0;
  margin-top: 4px;
  margin-bottom: 4px;
}

.ezInputErrorHighlight {
  background-color: var(--ezClockerInputErrorBackground);
  border-color: var(--ezBorderAlertRed);
  border-width: 2px;
  border-style: solid;
}

.ezInputWarningHighlight {
  background-color: var(--ezClockerInputWarningBackground);
  border-color: var(--ezBorderWarningYellow);
  border-width: 2px;
  border-style: solid;
}

.ezDisabledICheck {
  background-color: #e0e0e0;
  border-color: #6d6e70;
  opacity: 0.5;
  cursor: default;
}

.ezInputs-disabled-icheck {
  opacity: 0.5;
  cursor: default;
}

.ezInputs-important-data {
  font-size: 12pt;
}

.ezDisabledLabel {
  color: #e0e0e0;
}

.ezText-input-label-disabled {
  color: #e0e0e0;
  cursor: default;
}

.ez-input-validation-error {
  background-color: var(--ezClockerInputErrorBackground);
  border-color: var(--ezBorderAlertRed);
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {
}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {
}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  .ezInputs-large-fake-editor {
    display: grid;
    box-sizing: border-box;
    min-height: 30px;
    margin: 0;
    padding: 4px;
    justify-content: left;
    align-content: center;
    background-color: var(--ezClockerWhite);
    font-family: Roboto, Verdana, sans-serif;
    font-size: 12pt;
    border-color: var(--ezClockerSilver);
    border-style: solid;
    border-width: 1px;
    vertical-align: middle;
  }
  .ezInputs-large-full-width {
    box-sizing: border-box;
    width: 100%;
    font-size: 12pt;
  }
}
/* -------------------------------------------------------------------
| Warable Screen Style  (https://yesviz.com/watches.php)            |
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  .ezInputs-large-fake-editor {
    display: grid;
    box-sizing: border-box;
    min-height: 30px;
    margin: 0;
    padding: 4px;
    justify-content: left;
    align-content: center;
    background-color: var(--ezClockerWhite);
    font-family: Roboto, Verdana, sans-serif;
    font-size: 12pt;
    border-color: var(--ezClockerSilver);
    border-style: solid;
    border-width: 1px;
    vertical-align: middle;
  }
  .ezInputs-large-full-width {
    box-sizing: border-box;
    width: 100%;
    font-size: 12pt;
  }
}`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-inputs.css"],"names":[],"mappings":"AAAA;;;iEAAA;AAKA;EACI,mGAAA;EACA,uCAAA;AAAJ;;AAGA;;;;;;mEAAA;AAOA;EACI,qCAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,yBAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAGA;;;;;;mEAAA;AAOA;EACI,qBAAA;EACA,YAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;;EAEI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;;EAEI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,eAAA;EACA,iBAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;;;;;;;;mEAAA;AASA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;AAAJ;;AAGA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AAAJ;;AAGA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;AAAJ;;AAGA;;;;;;mEAAA;AAQA,sCAAA;AACA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAKA;EACI,4BAAA;EACA,iBAAA;EACA,yBAAA;AAFJ;;AAKA;EACI,4BAAA;EACA,iBAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,4BAAA;EACA,iBAAA;EACA,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EAEA,uDAAA;EACA,0CAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,kCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,mBAAA;EACA,mCAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,qCAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,cAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,6BAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,iBAAA;EACA,wCAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gDAAA;AAHJ;;AAMA;EACI,qCAAA;EACA,iDAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,uCAAA;EACA,qBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,sCAAA;AAHJ;;AAMA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,iBAAA;EACA,wCAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gDAAA;AAHJ;;AAMA;EACI,qCAAA;EACA,iDAAA;AAHJ;;AAMA;EACI,qBAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,qCAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,sCAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,8CAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,YAAA;EACA,uCAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,uCAAA;EACA,eAAA;EACA,8CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,uCAAA;EACA,eAAA;EACA,0CAAA;EACA,oDAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,oCAAA;EACA,qCAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,uCAAA;EACA,eAAA;EACA,8CAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,WAAA;EACA,WAAA;EACA,8CAAA;EACA,2BAAA;EACA,cAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,UAAA;AAHJ;;AAMA;EACI,UAAA;AAHJ;;AAMA;EACI,SAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,wCAAA;EACA,eAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,SAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;AAHJ;;AAMA;;;;EAII,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAHJ;;AAMA;;EAEI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAHJ;;AAMA;EACI,2BAAA;EACA,eAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,WAAA;EACA,eAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,WAAA;EACA,eAAA;AAHJ;;AAMA;;EAEI,eAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,sBAAA;EACA,WAAA;AAHJ;;AAMA;;EAEI,WAAA;EACA,sBAAA;AAHJ;;AAMA;EACI,UAAA;EACA,eAAA;EACA,kBAAA;AAHJ;;AAMA;EACI,sDAAA;EACA,qCAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,wDAAA;EACA,0CAAA;EACA,iBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;AAHJ;;AAMA;EACI,YAAA;EACA,eAAA;AAHJ;;AAMA;EACI,eAAA;AAHJ;;AAMA;EACI,cAAA;AAHJ;;AAMA;EACI,cAAA;EACA,eAAA;AAHJ;;AAMA;EACI,sDAAA;EACA,qCAAA;AAHJ;;AAOA;;qEAAA;AAGA;;;CAAA;AAKA;;qEAAA;AAGA;;;CAAA;AAMA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,YAAA;IACA,qBAAA;IACA,qBAAA;IACA,uCAAA;IACA,wCAAA;IACA,eAAA;IACA,oCAAA;IACA,mBAAA;IACA,iBAAA;IACA,sBAAA;EAPN;EAUE;IACI,sBAAA;IACA,WAAA;IACA,eAAA;EARN;AACF;AAYA;;qEAAA;AAGA;EACI;IACI,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,YAAA;IACA,qBAAA;IACA,qBAAA;IACA,uCAAA;IACA,wCAAA;IACA,eAAA;IACA,oCAAA;IACA,mBAAA;IACA,iBAAA;IACA,sBAAA;EAVN;EAaE;IACI,sBAAA;IACA,WAAA;IACA,eAAA;EAXN;AACF","sourcesContent":["/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| EzClocker Input UX CSS Classes\r\n| CSS variables defined in: /src/main/webapp/public/styles/common/ez-body.css\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\r\n\r\n:root {\r\n    --ezInputFontFamily: 'Font-Family-ezClocker', 'Roboto', 'Noto Sans', 'Verdana', 'Arial', sans-serif;\r\n    --ezInputMonospaceFontFamily: monospace;\r\n}\r\n\r\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Input Styles\r\n| Tags: <input/>\r\n|-------------------------------------------------------------------\r\n| Available Styles:\r\n|   input <default>\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\r\ninput {\r\n    font-family: var(--ezInputFontFamily);\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n    box-sizing: border-box;\r\n    /* Opera/IE 8+ */\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 0;\r\n    border-radius: 3px;\r\n}\r\n\r\ninput:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\r\n}\r\n\r\ninput:invalid {\r\n    background-color: #ffeeee;\r\n    border-color: #FF0700;\r\n    border-width: 1px;\r\n    box-shadow: none;\r\n}\r\n\r\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Select Input Styles\r\n| Tags: <select/>\r\n|-------------------------------------------------------------------\r\n| Available Styles:\r\n|   ezSelectMenu\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\r\nselect {\r\n    margin: 4px 4px 4px 0;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\nselect:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\r\n}\r\n\r\nselect.reportsOverride,\r\nselect.ez-reports-override {\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 4px 4px 4px 0;\r\n}\r\n\r\nselect.reportsOverride:focus,\r\nselect.ez-reports-override:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\r\n}\r\n\r\nselect.ezSelect {\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 4px 4px 4px 0;\r\n}\r\n\r\nselect.ezSelect:enabled:hover {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n}\r\n\r\nselect.ezSelect:enabled:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\r\n}\r\n\r\nselect.ezSelectHeader {\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 4px 4px 4px 0;\r\n}\r\n\r\nselect.ezSelectHeader:hover {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n}\r\n\r\nselect.ezSelectHeader:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\r\n}\r\n\r\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| Select Option Styles\r\n| Tags: <option/>\r\n|-------------------------------------------------------------------\r\n| Available Styles:\r\n|   option <tag default>\r\n|   ezOption\r\n|   ezOptionHeader\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\r\noption {\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 4px 4px 4px 0;\r\n}\r\n\r\noption:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\r\n}\r\n\r\noption.ezOption {\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n}\r\n\r\noption.ezOptionHeader {\r\n    font-size: 14pt;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    margin: 4px 4px 4px 0;\r\n}\r\n\r\noption.ezOptionHeader:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\r\n}\r\n\r\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\r\n| JQuery Select Input Styles\r\n| Tags: <select/>\r\n|-------------------------------------------------------------------\r\n| Available Styles:\r\n|   ezSelectMenu\r\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/\r\n\r\n/* for jQuery's SelectMenu component */\r\n.ezSelectMenu {\r\n    width: auto;\r\n    padding: 4px;\r\n    margin: 4px 4px 4px 0;\r\n    background-color: var(--ezClockerYellow);\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n\r\n}\r\n\r\n.ezSelectMenu:hover {\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    background-color: #ffdb64;\r\n}\r\n\r\n.ezSelectMenu:active {\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    border-color: #ffcc66;\r\n}\r\n\r\n.ezSelectMenu:disabled {\r\n    font-weight: normal;\r\n    background-color: #ffdb64;\r\n    color: #c69800;\r\n    border-color: #c69800;\r\n}\r\n\r\n.ezSelectMenu:focus {\r\n    color: var(--ezClockerBlack);\r\n    font-weight: bold;\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n\r\n    /* box-shadow: 0px 0px 2px 2px rgba(255, 153, 0, .2); */\r\n    box-shadow: 0 0 2px 1px rgb(255 153 0 / 30%);\r\n}\r\n\r\ninput[type=\"date\"].ezDate {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"date\"].ezDate:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"datetime\"].ezDateTime {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"datetime\"].ezDateTime:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"datetime-local\"].ezDateTimeLocal {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"datetime-local\"].ezDateTimeLocal:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"email\"].ezEmail {\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"email\"].ezEmail:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"file\"].ezFile {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"image\"].ezImage {\r\n    border-style: solid;\r\n    border-color: var(--ezClockerGray);\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"image\"].ezImage:hover {\r\n    border-style: solid;\r\n    border-color: var(--ezClockerBlack);\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"month\"].ezMonth {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"month\"].ezMonth:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"number\"].ezNumber {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"number\"].ezNumber:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"number\"].ezNumber:disabled {\r\n    color: #e0e0e0;\r\n    border-color: #e0e0e0;\r\n    outline-color: #e0e0e0;\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"password\"].ezPassword {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"password\"].ezPassword:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"radio\"].ezRadio {\r\n    background-color: transparent;\r\n}\r\n\r\ninput[type=\"reset\"].ezResetMajor {\r\n    display: inline-block;\r\n    padding: 6px 24px;\r\n    background-color: var(--ezClockerOrange);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezInputFontFamily);\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n    border-radius: 3px;\r\n    border: 1px solid var(--ezClockerBlack);\r\n    cursor: pointer;\r\n}\r\n\r\ninput[type=\"reset\"].ezResetMajor:hover {\r\n    background-color: #ffcc66;\r\n}\r\n\r\ninput[type=\"reset\"].ezResetMajor:active {\r\n    background-color: #ff9933;\r\n}\r\n\r\ninput[type=\"reset\"].ezResetActionButton {\r\n    display: inline-block;\r\n    padding: 6px 24px;\r\n    background-color: #8df13c;\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezInputFontFamily);\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n    border-radius: 3px;\r\n    border: 1px solid var(--ezActionGreenBorderColor);\r\n    cursor: pointer;\r\n}\r\n\r\ninput[type=\"reset\"].ezResetActionButton:hover {\r\n    background-color: var(--ezActionGreenHoverColor);\r\n}\r\n\r\ninput[type=\"reset\"].ezResetActionButton:active {\r\n    color: var(--ezActionGreenHoverColor);\r\n    background-color: var(--ezActionGreenBorderColor);\r\n}\r\n\r\ninput[type=\"reset\"].ezResetEdit {\r\n    display: inline-block;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezInputFontFamily);\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    border-radius: 3px;\r\n    border: 1px solid var(--ezClockerBlack);\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n\r\ninput[type=\"reset\"].ezResetEdit:hover {\r\n    background-color: #edf6ff;\r\n}\r\n\r\ninput[type=\"reset\"].ezResetEdit:active {\r\n    background-color: var(--ezClockerGray);\r\n}\r\n\r\ninput[type=\"search\"].ezSearch {\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerBlack);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"submit\"].ezMajorSubmit {\r\n    display: inline-block;\r\n    padding: 6px 24px;\r\n    background-color: var(--ezClockerOrange);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezInputFontFamily);\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n    border-radius: 3px;\r\n    border: 1px solid var(--ezClockerBlack);\r\n    cursor: pointer;\r\n}\r\n\r\ninput[type=\"submit\"].ezMajorSubmit:hover {\r\n    background-color: #ffcc66;\r\n}\r\n\r\ninput[type=\"submit\"].ezMajorSubmit:active {\r\n    background-color: #ff9933;\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitActionButton {\r\n    display: inline-block;\r\n    padding: 6px 24px;\r\n    background-color: #8df13c;\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezInputFontFamily);\r\n    font-size: 12px;\r\n    font-weight: bold;\r\n    text-decoration: none;\r\n    border-radius: 3px;\r\n    border: 1px solid var(--ezActionGreenBorderColor);\r\n    cursor: pointer;\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitActionButton:hover {\r\n    background-color: var(--ezActionGreenHoverColor);\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitActionButton:active {\r\n    color: var(--ezActionGreenHoverColor);\r\n    background-color: var(--ezActionGreenBorderColor);\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitEdit {\r\n    display: inline-block;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerOffWhite);\r\n    color: var(--ezClockerBlack);\r\n    font-family: var(--ezInputFontFamily);\r\n    font-size: 12px;\r\n    font-weight: normal;\r\n    text-decoration: none;\r\n    border-radius: 3px;\r\n    border: 1px solid var(--ezClockerBlack);\r\n    cursor: pointer;\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitEdit:hover {\r\n    background-color: #edf6ff;\r\n}\r\n\r\ninput[type=\"submit\"].ezSubmitEdit:active {\r\n    background-color: var(--ezClockerGray);\r\n}\r\n\r\ninput[type=\"tel\"].ezTel {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"tel\"].ezTel:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"text\"].ezText {\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"text\"].ezText:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"time\"].ezTime {\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"time\"].ezTime:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"url\"].ezUrl {\r\n    font-size: 12pt;\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"url\"].ezUrl:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ninput[type=\"week\"].ezWeek {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\ninput[type=\"week\"].ezWeek:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n}\r\n\r\ntextarea {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    font-size: 12pt;\r\n    font-family: 'Roboto', Verdana, sans-serif;\r\n    /* font-family: var(--ezInputMonospaceFontFamily); */\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\ntextarea:focus {\r\n    border-color: var(--ezClockerOrange);\r\n    outline-color: var(--ezClockerOrange);\r\n    outline-style: solid;\r\n    outline-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\ntextarea.mono-spaced {\r\n    padding: 4px;\r\n    background-color: var(--ezClockerWhite);\r\n    font-size: 12pt;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    border-color: var(--ezClockerGray);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n    border-radius: 3px;\r\n}\r\n\r\ntextarea.ez-error-message-details {\r\n    margin: 8px;\r\n    width: 100%;\r\n    font-family: var(--ezInputMonospaceFontFamily);\r\n    color: var(--ezClockerGray);\r\n    font-size: 6pt;\r\n    border-radius: 3px;\r\n}\r\n\r\ntextarea.ezTextArea-noresize-w100 {\r\n    resize: none;\r\n    width: 99%;\r\n}\r\n\r\ntextarea.ezTextArea-medium-100 {\r\n    width: 99%;\r\n}\r\n\r\n.ezInputs-large-fake-editor {\r\n    margin: 0;\r\n    min-height: 24px;\r\n    padding: 4px;\r\n    box-sizing: border-box;\r\n    background-color: var(--ezClockerWhite);\r\n    font-family: Roboto, Verdana, sans-serif;\r\n    font-size: 18pt;\r\n    border-color: var(--ezClockerSilver);\r\n    border-style: solid;\r\n    border-width: 1px;\r\n}\r\n\r\n.ezInputs-large-fake-editor-no-border {\r\n    margin: 0;\r\n    min-height: 24px;\r\n    padding: 4px;\r\n    box-sizing: border-box;\r\n    background-color: var(--ezClockerWhite);\r\n    color: var(--ezClockerNavy);\r\n    font-family: var(--ezInputFontFamily);\r\n    font-size: 14pt;\r\n    border-style: none;\r\n}\r\n\r\n.ezMajorInputLabel {\r\n    padding-top: 4px;\r\n    padding-bottom: 2px;\r\n    color: var(--ezFontColor);\r\n    font-weight: bold;\r\n    font-size: 16pt;\r\n}\r\n\r\n.ezInput-label-white-12pt-bold {\r\n    padding-top: 4px;\r\n    padding-bottom: 2px;\r\n    color: var(--ezClockerWhite);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\n.ezInput-label-black-12pt-bold {\r\n    padding-top: 4px;\r\n    padding-bottom: 2px;\r\n    color: var(--ezClockerBlack);\r\n    font-size: 12pt;\r\n    font-weight: bold;\r\n}\r\n\r\n.ezInput-label-black-14pt,\r\n.ezInputLabel,\r\n.ezEditorLabel,\r\n.editorLabel {\r\n    padding-top: 4px;\r\n    padding-bottom: 2px;\r\n    color: var(--ezFontColor);\r\n    font-size: 14pt;\r\n}\r\n\r\n.ezInput-label-black-14pt-bold,\r\n.ezBoldInputLabel {\r\n    padding-top: 4px;\r\n    padding-bottom: 2px;\r\n    color: var(--ezFontColor);\r\n    font-size: 14pt;\r\n}\r\n\r\n.ezInputs-checkbox-radio-label {\r\n    padding-top: 4px;\r\n    padding-bottom: 2px;\r\n    color: var(--ezFontColor);\r\n    font-size: 14pt;\r\n    line-height: 18px;\r\n    cursor: pointer;\r\n}\r\n\r\n.ezTogglesLabel {\r\n    color: var(--ezFontColor);\r\n    font-size: 14pt;\r\n    text-align: left;\r\n    vertical-align: middle;\r\n}\r\n\r\n.ezInputFormatLabel {\r\n    color: var(--ezClockerGray);\r\n    font-size: 10pt;\r\n}\r\n\r\n.ezLargeInputEditor {\r\n    font-size: 18pt;\r\n}\r\n\r\n.ezInputs-authentication-full-width {\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n    font-size: 18pt;\r\n}\r\n\r\n.ezInputs-large-full-width {\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n    font-size: 12pt;\r\n}\r\n\r\n.ezOversizedEditor,\r\n.oversizedEditor {\r\n    font-size: 16pt;\r\n    font-style: bold;\r\n}\r\n\r\n.ezDialogEditor {\r\n    font-size: 12pt;\r\n    box-sizing: border-box;\r\n    width: 100%;\r\n}\r\n\r\n.ezFullWidthEditor,\r\n.fullWidthEditor {\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.ezInputLabelGroupContainer {\r\n    padding: 0;\r\n    margin-top: 4px;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.ezInputErrorHighlight {\r\n    background-color: var(--ezClockerInputErrorBackground);\r\n    border-color: var(--ezBorderAlertRed);\r\n    border-width: 2px;\r\n    border-style: solid;\r\n}\r\n\r\n.ezInputWarningHighlight {\r\n    background-color: var(--ezClockerInputWarningBackground);\r\n    border-color: var(--ezBorderWarningYellow);\r\n    border-width: 2px;\r\n    border-style: solid;\r\n}\r\n\r\n.ezDisabledICheck {\r\n    background-color: #e0e0e0;\r\n    border-color: #6d6e70;\r\n    opacity: 0.5;\r\n    cursor: default;\r\n}\r\n\r\n.ezInputs-disabled-icheck {\r\n    opacity: 0.5;\r\n    cursor: default;\r\n}\r\n\r\n.ezInputs-important-data {\r\n    font-size: 12pt;\r\n}\r\n\r\n.ezDisabledLabel {\r\n    color: #e0e0e0;\r\n}\r\n\r\n.ezText-input-label-disabled {\r\n    color: #e0e0e0;\r\n    cursor: default;\r\n}\r\n\r\n.ez-input-validation-error {\r\n    background-color: var(--ezClockerInputErrorBackground);\r\n    border-color: var(--ezBorderAlertRed);\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 1023px) {\r\n}\r\n*/\r\n\r\n/* -------------------------------------------------------------------\r\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)       |\r\n------------------------------------------------------------------- */\r\n/*\r\n@media screen and (max-width: 768px) {\r\n}\r\n*/\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)             |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 480px) {\r\n    .ezInputs-large-fake-editor {\r\n        display: grid;\r\n        box-sizing: border-box;\r\n        min-height: 30px;\r\n        margin: 0;\r\n        padding: 4px;\r\n        justify-content: left;\r\n        align-content: center;\r\n        background-color: var(--ezClockerWhite);\r\n        font-family: Roboto, Verdana, sans-serif;\r\n        font-size: 12pt;\r\n        border-color: var(--ezClockerSilver);\r\n        border-style: solid;\r\n        border-width: 1px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .ezInputs-large-full-width {\r\n        box-sizing: border-box;\r\n        width: 100%;\r\n        font-size: 12pt;\r\n    }\r\n}\r\n\r\n\r\n/* -------------------------------------------------------------------\r\n| Warable Screen Style  (https://yesviz.com/watches.php)            |\r\n------------------------------------------------------------------- */\r\n@media screen and (max-width: 319px) {\r\n    .ezInputs-large-fake-editor {\r\n        display: grid;\r\n        box-sizing: border-box;\r\n        min-height: 30px;\r\n        margin: 0;\r\n        padding: 4px;\r\n        justify-content: left;\r\n        align-content: center;\r\n        background-color: var(--ezClockerWhite);\r\n        font-family: Roboto, Verdana, sans-serif;\r\n        font-size: 12pt;\r\n        border-color: var(--ezClockerSilver);\r\n        border-style: solid;\r\n        border-width: 1px;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .ezInputs-large-full-width {\r\n        box-sizing: border-box;\r\n        width: 100%;\r\n        font-size: 12pt;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
